module.exports = __webpack_public_path__ + "img/770-317525.png";